import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

import {
  Grid,
  Button,
  Checkbox,
  TextField,
  Autocomplete,
  FormControlLabel,
  Typography,
} from "@mui/material";

import { baseUrl, redirectUrl } from "config";
import { updateOrder } from "views/pos/slice/posSlice";

//--------// APIS_USED_FOR_THIS_COMPONENT //---------//
const GET_BANKS = "/getMasterAndSalesItem";

const PaymentModal = ({ onClose, onSave, loading }) => {
  const dispatch = useDispatch();
  const headerSlice = useSelector((state) => state.posSlice);
  const commonState = useSelector((state) => state.common);

  const [getBanks, setGetBanks] = useState([]);

  //   get banks
  useEffect(() => {
    const fetchDatas = async () => {
      try {
        const res = await axios.get(baseUrl + GET_BANKS, {
          withCredentials: true,
        });
        if (res) {
          setGetBanks(res.data[3]);
          dispatch(
            updateOrder({
              bank: res.data?.[3]?.[0],
            })
          );
        }
      } catch (error) {
        if (
          (error.response && error.response.status === 403) ||
          error.response.status === 401
        ) {
          redirectUrl();
        }
      }
    };
    fetchDatas();

    dispatch(
      updateOrder({
        netAmount: headerSlice.netTotal,
      })
    );
  }, []);

  //   Payment type change
  const handleButtonClick = (method) => {
    if (method === "Cash") {
      dispatch(
        updateOrder({
          bankAmount: 0,
          cashAmount: 0,
          split: false,
          bank: null,
          type: method,
        })
      );
    } else {
      dispatch(
        updateOrder({
          bank: getBanks[0],
          bankAmount: headerSlice.cashReceived,
          type: method,
        })
      );
    }
  };

  // Handle input changes for text fields
  const handleTextFieldChange = (e, field) => {
    const { value, type } = e.target;

    dispatch(
      updateOrder({
        [field]: type === "number" ? Number(value) : value,
      })
    );
  };

  const handleCashRec = (e) => {
    const { value } = e.target;

    dispatch(
      updateOrder({
        cashReceived: Number(value),
        bankAmount: headerSlice.type !== "Cash" ? Number(value) : 0,
      })
    );
  };

  const handleSplit = (e) => {
    dispatch(
      updateOrder({
        split: e.target.checked,
        bankAmount: headerSlice?.cashReceived,
        cashAmount: 0,
      })
    );
  };

  const handleBankAmt = (e) => {
    const { value } = e.target;
    const cashAmt = headerSlice.cashReceived - Number(value);

    dispatch(
      updateOrder({
        bankAmount: Number(value),
        cashAmount: cashAmt,
      })
    );
  };

  const handleCashAmt = (e) => {
    const { value } = e.target;
    const bankAmt = headerSlice.cashReceived - Number(value);
    dispatch(
      updateOrder({
        cashAmount: Number(value),
        bankAmount: bankAmt,
      })
    );
  };
  return (
    <Grid container spacing={2}>
      {/* Payment Method Buttons */}
      <Grid item xs={6} sm={4} md={3}>
        <Button
          variant="contained"
          fullWidth
          color={headerSlice.type === "Cash" ? "success" : "info"}
          onClick={() => handleButtonClick("Cash")}
        >
          Cash
        </Button>
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <Button
          variant="contained"
          fullWidth
          color={headerSlice.type === "Credit Card" ? "success" : "info"}
          onClick={() => handleButtonClick("Credit Card")}
        >
          Credit Card
        </Button>
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <Button
          variant="contained"
          fullWidth
          color={headerSlice.type === "Debit Card" ? "success" : "info"}
          onClick={() => handleButtonClick("Debit Card")}
        >
          Debit Card
        </Button>
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <Button
          variant="contained"
          fullWidth
          color={headerSlice.type === "UPI" ? "success" : "info"}
          onClick={() => handleButtonClick("UPI")}
        >
          UPI
        </Button>
      </Grid>

      {/* Split Checkbox */}
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={headerSlice.split}
              //   onChange={(e) => setIsSplit(e.target.checked)}
              onChange={handleSplit}
              disabled={headerSlice.type === "Cash"} // Disable when "Cash" is selected
            />
          }
          label="Split"
        />
      </Grid>

      {/* Bank Autocomplete */}

      <Grid item xs={12}>
        {/* <Autocomplete
          value={headerSlice.bank}
          disabled={headerSlice.type === "Cash"}
          onChange={
            (e, newValue) => setDetails((prev) => ({ ...prev, bank: newValue }))
            // && setIsCashReceivedTouched(true)
          }
          options={getBanks}
          renderInput={(params) => (
            <TextField {...params} label="Bank" fullWidth variant="outlined" />
          )}
        /> */}
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          value={headerSlice.bank}
          onChange={(e, newValue) => dispatch(updateOrder({ bank: newValue }))}
          options={getBanks}
          getOptionLabel={(option) => option.Name}
          renderInput={(params) => <TextField {...params} label="Bank" />}
        />
      </Grid>

      {/* Net Amount */}
      <Grid item xs={12}>
        <TextField
          type="number"
          label="Net Amount"
          fullWidth
          variant="outlined"
          value={headerSlice.netAmount.toFixed(commonState.decimalCount || 0)}
          onChange={(e) => handleTextFieldChange(e, "netAmount")}
        />
      </Grid>

      {/* Narration */}
      <Grid item xs={12}>
        <TextField
          label="Narration"
          fullWidth
          variant="outlined"
          value={headerSlice.narration}
          onChange={(e) => handleTextFieldChange(e, "narration")}
        />
      </Grid>

      {/* Cash Received */}
      <Grid item xs={12}>
        <TextField
          type="number"
          label="Cash Received"
          fullWidth
          variant="outlined"
          value={headerSlice.cashReceived || 0}
          onChange={handleCashRec}
        />
      </Grid>

      {/* Bank Amount */}
      {headerSlice.type !== "Cash" && (
        <Grid item xs={headerSlice.split ? 6 : 12}>
          <TextField
            type="number"
            label="Bank Amount"
            fullWidth
            variant="outlined"
            value={headerSlice.bankAmount}
            onChange={handleBankAmt}
          />
        </Grid>
      )}

      {/* Cash Amount (only if Split is enabled) */}
      {headerSlice.split && (
        <Grid item xs={headerSlice.split ? 6 : 12}>
          <TextField
            type="number"
            label="Cash Amount"
            fullWidth
            variant="outlined"
            value={headerSlice.cashAmount}
            onChange={handleCashAmt}
          />
        </Grid>
      )}

      {/* Balance */}
      <Grid item xs={12}>
        <Typography variant="body2">Balance: {headerSlice.balance.toFixed(commonState.decimalCount || 0)}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Button variant="outlined" fullWidth onClick={onClose} color="error">
          Cancel
        </Button>
      </Grid>
      <Grid item xs={6}>
        <Button
          // disabled={!isCashReceivedTouched}
          disabled={loading}
          variant="contained"
          color="primary"
          fullWidth
          onClick={onSave}
          loadingIndicator="Loading…"
        // loading={true}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  );
};

export default PaymentModal;